<template>
    <a-modal v-bind:open="computedShowModal"
        width="720px"
        :closable="true"
        :footer="null"
        :mask-closable="true"
        :mask-style="{backdropFilter: 'blur(2px)'}"
        :keyboard="false"
        :title="$t('productslist_modify_product')"
        :centered="true"
        @cancel="closeModal"
    >
        <div class="modal-content-body">
            <div class="modal-input-area">
                <div class="label-wrap">
                    <i class="fa-solid fa-barcode-read"/>
                    <label>{{ $t('productslist_item_code') }}
                        <span class="required-span"/>
                    </label>
                </div>
                <a-select 
                    v-model:value="selectedItemId" 
                    @change="onChangeItem" 
                    class="content-part"
                    :placeholder="$t('productslist_item_placeholder')"
                    :not-found-content="null"
                    :defaultActiveFirstOption="true"
                >
                    <a-select-option 
                        v-for="item in itemsList"
                        :value="item._id" 
                        :key="item._id"
                    >
                        {{ `${item.itemName} / ${item.itemCode}` }}
                    </a-select-option>
                </a-select>
            </div>
            <div class="modal-input-area">
                <div class="label-wrap">
                <i class="fa-solid fa-barcode-read"/>
                <label>{{ $t('productslist_table_code') }}
                    <span class="required-span"/>
                </label>
                </div>
                <a-input
                    v-model:value="productDetailData.productCode" 
                    :placeholder="$t('productslist_productcode_placeholder')" 
                />
            </div>
            <div class="modal-input-area align-top">
                <div class="label-wrap label-wrap-align-top">
                    <i class="fa-light fa-message-lines"/>
                    <label>{{ $t('productslist_desc') }}</label>
                </div>
                <a-textarea 
                    v-model:value="productDetailData.description" 
                    :placeholder="$t('productslist_description_placeholder')"
                />
            </div>
        </div>
        <div class="modal-footer">
            <a-button
                @click="closeModal"
            >
                {{ $t('common_cancel') }}
            </a-button>
            <a-button
                type="primary"
                @click="validate"
            >
                {{ $t('productslist_table_modify') }}
            </a-button>
        </div>
    </a-modal>
</template>
<script>
    import { oneBtnDialog } from '@/utils/utils';
    import { modalType } from '../enums/enums';

    export default {
        data() {
            return {
                selectedItemId: '',
                itemsList: [],
                productDetailData: {
                    itemName: '',
                    itemCode: '',
                    itemNo: '',
                    description: '',
                    productId: '',
                    productCode: '',
                    jsonContents: [],
                },
            };
        },
        props: {
            showModal: {
                type: Boolean,
                required: true,
                default: false,
            },
            id: {
                type: String,
                reqiured: true,
                default: '',
            },
        },
        async mounted() {
            await this.getItems();
        },
        emits: ['closeModal', 'getProductsList',],
        computed: {
            computedShowModal() {
                return this.showModal;
            },
            formattedItems() {
                return this.itemsList.map(item => ({
                    value: item._id,
                    label: `${item.itemName} / ${item.itemCode}`
                }))
            }
        },
        watch: {
            showModal: {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    if(newValue) {
                        this.handleWhenModalOpened();
                    }
                },
            }
        },
        methods: {
            closeModal() {
                this.$emit('closeModal', modalType.modify, false);
                this.$emit('getProductsList');
                this.initData();
            },
            initData() {
                this.selectedItemId = '';
                this.itemsList = [];
                this.productDetailData = {
                    itemName: '',
                    itemCode: '',
                    itemNo: '',
                    description: '',
                    productId: '',
                    productCode: '',
                    jsonContents: [],
                };
            },
            async handleWhenModalOpened() {
                await this.getItems();
                await this.getProductDetail(this.id);
            },
            async getProductDetail(productId) {
                try {
                    const response = await this.$apiInstance.get(`/products/${productId}`);
                    if (response.status === 200 || response.status === 201) {
                        this.productDetailData = response.data;
                        this.selectedItemId = this.itemsList.find(item => item._id === response.data.itemId)?._id;
                        this.productDetailData.productId = productId;
                    }
                } catch (error) {
                    console.log(error);
                    await oneBtnDialog(this.$i18n.t('productslist_single_load_err_title'), this.$i18n.t('productslist_single_load_err_content'), false);
                }
            },
            // 업로드 전 검증
            async validate() {
                if (this.productDetailData.productCode !== '') {
                    this.updateProduct();
                } else {
                    await oneBtnDialog(this.$i18n.t('productslist_nocode_err_msg_title'), this.$i18n.t('productslist_nocode_err_msg_content'), false);
                }
            },

            // 품목 가져오기
            async getItems() {
                try {
                    const response = await this.$apiInstance.get(`/products/item/list`);
                    if (response.status === 200 || response.status === 201) {
                        this.itemsList = response.data;
                    }
                } catch(error) {
                    console.log(error);
                    await oneBtnDialog(this.$i18n.t('itemslist_err_title'), this.$i18n.t('itemslist_err_content'), false);
                }
            },
            handleFilterOption(input, option) {
                // console.log(input, option)
                const item = this.itemsList.find(item => item._id === option.value);
                if (item) {
                    const itemName = item.itemName.toLowerCase();
                    const itemCode = item.itemCode.toLowerCase();
                    const inputText = input.toLowerCase();
                    return itemName.includes(inputText) || itemCode.includes(inputText);
                }
                return false;
            },
            onChangeItem(event) {
                const result = this.itemsList.find(item => item._id === event)
                if(result) {
                    this.productDetailData.description = result.description;
                } else {
                    this.productDetailData.description = '';
                }
            },
            // 제품 업데이트
            async updateProduct() {
                const obj = {};
                if (this.selectedItemId) obj.itemId = this.selectedItemId; // 품목코드 
                if (this.productDetailData.productCode) obj.productCode = this.productDetailData.productCode;
                if(this.productDetailData.description) {
                    obj.description = this.productDetailData.description;
                } else {
                    obj.description = '';
                }

                try {
                    const response = await this.$apiInstance.put(`/products/${this.id}`, obj);
                    if (response.status === 200 || response.status === 201) {
                        await oneBtnDialog(this.$i18n.t('productslist_modify_done_msg_title'), this.$i18n.t('productslist_modify_done_msg_content'), false);
                        this.closeModal();
                    }
                } catch(error) {
                    console.log(error);
                    if(error.response && error.response.status === 400) {
                        await oneBtnDialog(this.$i18n.t('productslist_existcode_err_msg_title'), this.$i18n.t('productslist_existcode_err_msg_content'), false);
                    } else {
                        await oneBtnDialog(this.$i18n.t('productslist_modify_fail_msg_title'), this.$i18n.t('productslist_modify_fail_msg_content'), false);
                    }
                }
            },
        },
    };
</script>
<style lang="scss" scoped>

$Gray-10: #F3F5F6;
$Gray-20: #e8ebed;
$Gray-50: #ACB2B9;
$Gray-60: #8D939A;
$Gray-70: #6e747c;
$Gray-80: #4B5158;
$Gray-90: #2F3337;
$Gray-100 : #17191C;
$CertiLifeYellow: #ffe414;

.modal-content-body {
    padding: 20px;
}

.modal-input-area {
    display: flex;
    // justify-content: center;
    align-items: center;
    padding: 7px 0;
    width: 100%;

    .content-part {
        width: 80%;
    }
    .label-wrap {
        display: flex;
        align-items: center;
        width: 20%;
        // margin: 0 10px 0 0;
        i {
            margin-right: 5px;
            color: rgb(75, 81, 88);
            font-size: 15px;
        }

        label {
            margin-bottom: 0 !important;
            color: rgb(75, 81, 88);
            font-size: 15px;
            font-weight: 500;
            text-align: start;
            display: flex;
            .required-span {
                width: 6px;
                height: 6px;
                border-radius: 100%;
                background-color: #FB574B;
                margin-left: 3px;
                display: block;
                margin-top: 2px;
            }
        }
    }

    .label-wrap-align-top {
        padding-top: 15px !important;
    }

    select {
        width: 80%;
        border-radius: 6px;
        border: solid 1px rgba(0, 0, 0, 0.2);
        height: 40px;
    }

    textarea {
        width: 80%;
        border-radius: 6px;
        border: solid 1px rgba(0, 0, 0, 0.2);
        height: 100px;
        resize: none;
        padding: 7px 14px;
        &:disabled {
            background-color: $Gray-10;
        }
    }

    // 제품정보보기
    .props-wrap {
        width: 80%;
    }

    .prop {
        width: 100%; 
        display: flex;
    }

    .json-key {
        display:flex;
        flex-direction: column; 
        margin-right: 2.5%; 
        width: 47.5%;
    }

    .json-value {
        display:flex;
        flex-direction: column; 
        margin-left: 2.5%; 
        width: 47.5%;
    }

    input[type=text],
    input[type=password] {
        width: 80%;
        border-radius: 6px;
        border: solid 1px rgba(0, 0, 0, 0.2);
        height: 40px;
        padding: 0 14px;
        &:disabled {
            background-color: $Gray-10;
        }
    }

    input[type=checkbox] {
        accent-color: #ffd814;
        width: 10px;
    }

    input[type=file] {
        display: none;
    }

    div {

        input[type="text"] {
            width: 100%;
            margin-top: 5px;
            border-radius: 6px;
        }

        input[type="file"] {
            opacity: 0;
            position: absolute;
            width: 18%;
            right: 8%;
        }

        button {
            background-color: #FFD814;
            padding: 5px 10px;
            border: none;
            border-radius: 8px;
            font-weight: bold;
            font-size: 0.8rem;
            float: right;
        }
    }
}

select {
    width: 100%;
}

.modal-input-area:last-child {
    padding: 7px 0 0 0;
}

.modal-footer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px 20px 20px;
    // padding: 20px;
    gap: 10px;
    .button {
        border-radius: 0px;
        color: $Gray-90;
    }
}
</style>